export const PhoneFrame = ({ src, alt, className = '', priority = false }) => (
  <div
    className={`relative rounded-[46px] bg-gradient-to-b from-[#4b504e] via-[#2c3130] to-[#1d2120] p-[3px] shadow-[0_32px_64px_-24px_rgba(11,31,26,0.5)] ${className}`}
  >
    <span aria-hidden="true" className="absolute -left-[2.5px] top-[88px] h-7 w-[3px] rounded-l-md bg-[#3a3f3d]" />
    <span aria-hidden="true" className="absolute -left-[2.5px] top-[126px] h-11 w-[3px] rounded-l-md bg-[#3a3f3d]" />
    <span aria-hidden="true" className="absolute -left-[2.5px] top-[176px] h-11 w-[3px] rounded-l-md bg-[#3a3f3d]" />
    <span aria-hidden="true" className="absolute -right-[2.5px] top-[120px] h-16 w-[3px] rounded-r-md bg-[#3a3f3d]" />
    <div className="rounded-[43px] bg-[#101312] p-[7px]">
      <div className="relative overflow-hidden rounded-[37px] bg-[#FAFAF7]">
        <div
          aria-hidden="true"
          className="absolute left-1/2 top-[9px] z-10 h-[17px] w-[72px] -translate-x-1/2 rounded-full border border-[#1c1f1e] bg-black"
        />
        <img
          src={src}
          alt={alt}
          loading={priority ? 'eager' : 'lazy'}
          decoding="async"
          className="block h-auto w-full"
        />
      </div>
    </div>
  </div>
);
